import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

import { IconComponent } from '../../../icon/icon.component';
import { BaseButtonDirective } from '../../base-button';
import { RtPlanButtonVariant } from '../../button.types';

@Component({
  standalone: true,
  selector: 'rt-plan-button, a[rt-plan-button]',
  templateUrl: './plan-button.component.html',
  styleUrls: ['./../../styles/base.less', './plan-button.component.less'],
  // eslint-disable-next-line
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, NgIf],
})
export class PlanButtonComponent extends BaseButtonDirective {
  @Input() public variant: RtPlanButtonVariant | 'tertiary' = 'scale';
  @Input() public hasIcon: boolean = true;
}
